import React, { Component } from "react";
import MyNavbar from "../../components/Navbar/MyNavbar";

import ClientList from "../../components/client/ClientRegistration/CLientList";

export default class ClientListPage extends Component {
  render() {
    return (
      <div>
        <MyNavbar />
        <ClientList />
      </div>
    );
  }
}
